const STAGE_LABELS = { page_view: "Page View", play: "Play Track", outbound: "Outbound Click" };
const STAGE_COLORS = ["#818CF8", "#10B981", "#F59E0B"];

export const ConversionFunnelWidget = ({ data, loading }) => {
  const funnel = data?.funnel || [];
  const max = funnel[0]?.count || 1;

  return (
    <div data-testid="conversion-funnel-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Play-to-Save Funnel</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : max === 0 ? (
        <p className="text-sm text-slate-500">No funnel activity yet.</p>
      ) : (
        <div className="space-y-3">
          {funnel.map((stage, i) => {
            const pct = max ? (stage.count / max) * 100 : 0;
            const dropoff = i > 0 && funnel[i - 1].count ? Math.round(100 - (stage.count / funnel[i - 1].count) * 100) : null;
            return (
              <div key={stage.stage}>
                <div className="flex items-center justify-between text-xs mb-1">
                  <span className="text-slate-300">{STAGE_LABELS[stage.stage] || stage.stage}</span>
                  <span className="font-mono text-slate-400">{stage.count}{dropoff !== null && <span className="text-rose-400 ml-2">-{dropoff}%</span>}</span>
                </div>
                <div className="h-3 rounded-full bg-white/5 overflow-hidden">
                  <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: STAGE_COLORS[i] }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
